import { render, staticRenderFns } from "./DashboardTableCampaign.vue?vue&type=template&id=7490179e&"
import script from "./DashboardTableCampaign.vue?vue&type=script&lang=js&"
export * from "./DashboardTableCampaign.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTableCampaign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports